import { type PropsWithChildren, useMemo } from 'react';

import type { PostTheme, UTMAttrs } from '@/types';

import { PostContentContext } from './context';

type Props = PropsWithChildren<{
  utmParams?: UTMAttrs;
  postTheme?: PostTheme;
  eagerImageSrc?: string;
}>;

export function PostContentProvider({ children, utmParams, postTheme, eagerImageSrc }: Props) {
  const value = useMemo(() => ({ utmParams, postTheme, eagerImageSrc }), [utmParams, postTheme, eagerImageSrc]);

  return <PostContentContext.Provider value={value}>{children}</PostContentContext.Provider>;
}
